import { FormLogoHeader } from '@/components/dialogs/Registration/components/FormHeader/FormLogoHeader';
import type { RegistrationConfig, RegistrationTheme } from '../types';

const DARKLE_REG_THEME: RegistrationTheme = {
  bg: '#1F202C',
  color: '#9A9CAC',
  formMarginBottom: '24px',
  colorLinks: '#00B83E',
  contentPaddingTop: '12px',
  footer: {
    bg: '#323444',
    fontColor: '#9A9CAC',
  },
  steps: {
    bg: '#323444',
    inactive: '#1F202C',
    active: '#EA5B0C',
    color: '#fff',
  },
  input: {
    bg: '#0E111A',
    borderRadius: '12px',
    colorInput: '#fff',
    color: '#9A9CAC',
    height: '48px',
    borderColorFocus: '#00B83E',
  },
  inputLabel: {
    color: '#fff',
  },
  regBanner: {
    marginBottom: '16px',
  },
  countryTooltip: {
    color: '#fff',
    textColor: '#fff',
  },
  select: {
    bg: '#0E111A',
    borderRadius: '12px',
    colorInput: '#fff',
    color: '#9A9CAC',
    height: '48px',
    borderActive: '#00B83E',
    activeOptionBg: '#1F202C',
    disabledArrowColor: '#323444',
  },
  checkbox: {
    wrapperMargin: 8,
    color: '#fff',
    notActiveBorder: '#8E8E93',
    notActiveBg: '#1F202C',
    activeColor: '#00B83E',
  },
};

export const DARKLE_REG_CONFIG: RegistrationConfig = {
  head: {
    render: () => <FormLogoHeader />,
  },
  input: {
    withInsideLabel: true,
  },
  select: {
    withInsideLabel: true,
  },
  buttons: {
    regButton: {
      colorMode: { secondaryGreenGradient: true },
      isRegistrationSticky: true,
      text: 'common:button.joinNow',
    },
    googleRegButton: {
      colorMode: { whiteTransparent: true },
      borderRadius: '12px',
      wrapBorderRadius: '12px',
    },
    next: {
      colorMode: { secondaryGreenGradient: true },
    },
    back: {
      colorMode: { secondaryGrayGradient: true },
    },
    borderRadius: '12px',
    wrapBorderRadius: '10px',
  },
  checkbox: {
    termsLinkText: 'auth.registration.form.acceptTermsConditionsShort',
  },
  withPayments: false,
  withNavigationOnFirstStep: true,
  styleScheme: DARKLE_REG_THEME,
};
